const normalize = (value)=>value.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
const scoreTerm = (term, candidate)=>{
    if (candidate === term) return 1;
    if (candidate.startsWith(term)) return 0.9;
    if (candidate.split(/[^\p{L}\p{N}]+/u).some((word)=>word.startsWith(term))) return 0.75;
    return candidate.includes(term) ? 0.5 : 0;
};
/** Matches every search term and grades exact, prefix, word, then substring relevance. */ export function matchesSearchTerms(search, candidates) {
    const query = normalize(search);
    if (!query) return 1;
    const normalizedCandidates = candidates.filter((candidate)=>Boolean(candidate)).map(normalize);
    if (normalizedCandidates.some((candidate)=>candidate === query)) return 1;
    if (normalizedCandidates.some((candidate)=>candidate.startsWith(query))) return 0.9;
    const termScores = query.split(' ').map((term)=>Math.max(0, ...normalizedCandidates.map((candidate)=>scoreTerm(term, candidate))));
    if (termScores.some((score)=>score === 0)) return 0;
    return termScores.reduce((sum, score)=>sum + score, 0) / termScores.length;
}
